import { FC } from 'react';
import { Box, BoxProps } from '@mui/material';


export const TopActions: FC<BoxProps> = ({ children, ...props }) => {
  return (
    <Box
      top={-46}
      left={0}
      position="absolute"
      {...props}
    >
      {children}
    </Box>
  );
};